var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalAction
    ? _c(
        "b-modal",
        {
          attrs: {
            id: "seasonRateManagementModal",
            title: _vm.modalAction.Title,
            size: "x",
            "hide-footer": "",
            "no-close-on-backdrop": ""
          },
          on: { hide: _vm.hide }
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("Your TextArea Field Title"),
                            error: _vm.$v.customerCodesTextarea,
                            md: "12",
                            lg: "12"
                          }
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              placeholder: "Enter customer codes here",
                              rows: "5"
                            },
                            model: {
                              value: _vm.customerCodesTextarea,
                              callback: function($$v) {
                                _vm.customerCodesTextarea = $$v
                              },
                              expression: "customerCodesTextarea"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { cols: "12" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mx-2",
                          attrs: { size: "sm", variant: "danger" },
                          on: { click: _vm.save }
                        },
                        [_vm._v(_vm._s(_vm.$t("index.remove")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f3dee15", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3dee15","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/SeasonRateManagementModal.vue
// module id = null
// module chunks = 